import Vimeo, { Player }from '@vimeo/player';
import get from 'lodash/get';
import some from 'lodash/some';
import { RawVenue } from 'spc/lib/database/types/venue/venue';

class VideoPlayer {
  venue: RawVenue;
  currentVideoType: string;
  hasFullVideo: boolean;
  hasTeaserVideo: boolean;
  hasVideo: boolean;
  videoType: string;
  videoTitle: string;
  venueVideo: {
    videoPlayerType: string;
    image: string;
    images: [
      {
        src: string;
        type: string;
      }
    ];
    sources: [
      {
        file: string;
      }
    ];
  };

  showVideoPlaceholder: boolean;
  myVimeoPlayerInstance: InstanceType< typeof Vimeo >;
  constructor( private unwrapError ) {
    'ngInject';
  }

  $onInit() {
    this.checkVideoPlayerType();
    this.setFullOrTeaser();
    this.setVenueVideo()
      .then(() => {
        if (this.currentVideoType === 'JWPlayer') {
          return;
        } else if (this.currentVideoType === 'Vimeo') {
          this.playVideoWithVimeoPlayer();
        }
      })
      .catch( error => this.unwrapError(error));
  }

  public checkVideoPlayerType = () => {
    const videos = get(this.venue.data, 'videos');
    if (!videos.length) {
      return;
    }
    videos.forEach((vid) => {
      if (vid.title === 'Video') {
        this.currentVideoType = vid.videoPlayerType;
      }
      else if (vid.title === 'Teaser') {
        this.currentVideoType = vid.videoPlayerType;
      }
      else {
        this.currentVideoType = vid.videoPlayerType;
      }
    });
  }

  public setFullOrTeaser = async () => {
    const videos = get(this.venue.data, 'videos');
    this.hasFullVideo = some(videos, { title: 'Full' });
    this.hasTeaserVideo = some(videos, { title: 'Teaser' });
    this.hasVideo = some(videos, { title: 'Video' });
    if (videos.length === 1) {
      this.videoType = videos[0].title;
      this.currentVideoType = videos[0].videoPlayerType;
    } else if (this.hasVideo) {
      this.videoType = 'Video';
    }
    else if (this.hasTeaserVideo) {
      this.videoType = 'Teaser';
    }
    else if (this.hasFullVideo) {
      this.videoType = 'Full';
    }
  }

  public setVenueVideo = async () => {
    const videos = get(this.venue.data, 'videos');
    if (!videos.length) {
      return;
    }
    videos.forEach((video) => {
      if (this.videoType === 'Full' && video.title === 'Full') {
        this.hasFullVideo = true;
        this.videoTitle = video.title;
        this.venueVideo = {
          videoPlayerType: video.videoPlayerType,
          image: video.thumbnail,
          images: [
            {
              src: video.thumbnail,
              type: 'video/mp4',
            },
          ],
          sources: [
            {
              file: video.url,
            },
          ],
        };
      } else if (this.videoType === 'Teaser' && video.title === 'Teaser') {
        this.hasTeaserVideo = true;
        this.videoTitle = video.title;
        this.venueVideo = {
          videoPlayerType: video.videoPlayerType,
          image: video.thumbnail,
          images: [
            {
              src: video.thumbnail,
              type: 'video/mp4',
            },
          ],
          sources: [
            {
              file: video.url,
            },
          ],
        };
      }
      else if (this.videoType === 'Video' && video.title === 'Video') {
        this.hasVideo = true;
        this.videoTitle = video.title;
        this.venueVideo = {
          videoPlayerType: video.videoPlayerType,
          image: video.thumbnail,
          images: [
            {
              src: video.thumbnail,
              type: 'video/mp4',
            },
          ],
          sources: [
            {
              file: video.url,
            },
          ],
        };
      }
    });
  }

  public playVideoWithVimeoPlayer = () => {

    let data;
    const videoUrl = this.venueVideo.sources[0].file;
    if (videoUrl.includes('https://vimeo.com')) {

      const videoKey = videoUrl.split('/').pop().split('?')[0];
      data = Number(videoKey);
    }

    const options = {
      id: data,
      width: 642,
      controls: true,
      autoplay: true,
      muted: true,
      title: false,
    };
    this.showVideoPlaceholder = false;
    setTimeout(() => {

      this.myVimeoPlayerInstance = new Vimeo('vimeoPlayerDiv', options);
    }, 500);

  }

  public setVideoType = (type) => {
    this.videoType = type;
    this.setVenueVideo()
      .then(() => {
        if (this.venueVideo.videoPlayerType === 'Vimeo') {
          if ( this.myVimeoPlayerInstance ) {
            this.myVimeoPlayerInstance.destroy();
          }
          this.playVideoWithVimeoPlayer();
        }
      })
      .catch(error => this.unwrapError(error));
  }

  public showVenueVideoContainer = () => {
    const videos = get(this.venue, 'data.videos');
    if (videos.length) {
      return true;
    }
    return false;
  }
}

export const VideoPlayerComponent = {
  template: require('./video-player.component.jade'),
  bindings: {
    venue: '<',
  },
  controller: VideoPlayer,
};
